import { useRouter } from 'next/router';
import * as React from 'react';
import { useEffect } from 'react';

import Loader from '~/components/Loader';
import { routes } from '~/constants/routes';
import { USER_ROLES, useSession } from '~/contexts/session';

export default function Home() {
  const route = useRouter();
  const { role } = useSession();

  useEffect(() => {
    if (
      role === USER_ROLES.creatorEcho ||
      role === USER_ROLES.creatorFoam ||
      role === USER_ROLES.creatorManaged
    ) {
      route.push(routes.influencersMessages);
    } else {
      route.push(routes.default);
    }
  }, [route, role]);

  return <Loader />;
}
